import jquery from 'jquery'
window.jQuery = jquery
window.jquery = jquery
window.$ = jquery
import 'bootstrap/dist/js/bootstrap'
